<template>
  <b-modal
    v-model="isOpen"
    has-modal-card
    trap-focus
    scroll="keep"
    aria-role="dialog"
    aria-label="CommentaireModal"
    :aria-modal="true"
    class="CommentaireModal"
    @cancel="emitCloseModale"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <H3TitleView class="modal-card-title"
          >{{ $t("instruction-panel.echanges.commentaire") }}
        </H3TitleView>
        <div class="ActualitesModalView-infos">
          {{
            `${$t("instruction-panel.echanges.date-creation")} ${formatDate(
              commentaireCopy.dateCreation,
            )}${
              commentaireCopy.auteur
                ? " par " + commentaireCopy.auteur.prenom + " " + commentaireCopy.auteur.nom
                : ""
            }`
          }}
        </div>
      </header>

      <section class="modal-card-body">
        <InputWithValidation
          v-model="contenu"
          class="echanges-content"
          type="textarea"
          :label="$t('instruction-panel.echanges.content')"
          maxlength="1400"
          vid="commentaire-content"
          :disabled="true"
        />
      </section>

      <footer class="modal-card-foot">
        <div class="buttons">
          <div class="hoverable-discrete-link mr-3" @click="emitCloseModale">
            {{ $t("close-generic") }}
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { EchangeDTO } from "@/model/bean/GeneratedDTOs"

import H3TitleView from "@/views/commons/H3TitleView.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import { BModal } from "buefy"

import DateUtils from "@/services/DateUtils"

export default defineComponent({
  name: "CommentaireModalView",
  components: {
    H3TitleView,
    InputWithValidation,
    BModal,
  },
  props: {
    commentaire: {
      type: Object as PropType<EchangeDTO>,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["close"],
  data() {
    return {
      commentaireCopy: { ...this.commentaire },
    }
  },
  computed: {
    isOpen: {
      get(): boolean {
        return this.open
      },
      set(value: boolean): void {
        if (!value) {
          this.emitCloseModale()
        }
      },
    },
    contenu: {
      get(): string {
        return this.commentaireCopy.contenu
      },
      set(): void {
        // Ne rien faire puisque le champ est en lecture seule
      },
    },
  },
  watch: {
    commentaire: {
      handler(newCommentaire) {
        this.commentaireCopy = { ...newCommentaire }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    emitCloseModale(): void {
      this.$emit("close")
    },

    formatDate(date: Date): string {
      return DateUtils.formatDate(date)
    },
  },
})
</script>

<style lang="scss">
.CommentaireModal {
  &.modal .modal-card {
    height: 65%;
    overflow-y: auto !important;
  }

  .animation-content {
    height: 100%;
  }

  .echanges-content textarea {
    height: 320px;
  }
}

.CommentaireModalView-infos {
  font-style: italic;
}
</style>
